(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionId = '{{ section.id }}';
    var hero = document.getElementById('Hero-' + sectionId);
    if (!hero || hero.dataset.parallax !== 'true') return;

    var mediaWrapper = hero.querySelector('.hero__media-wrapper');
    if (!mediaWrapper) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var intensity = parseFloat(hero.dataset.parallaxIntensity) || 30;
    // At intensity 100, max offset = 150px each direction
    var maxOffset = intensity * 1.5;

    function applyParallax() {
      var rect = hero.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var total = rect.height + viewportHeight;
      var scrolled = viewportHeight - rect.top;
      var progress = Math.max(0, Math.min(1, scrolled / total));
      // progress 0 = hero entering from bottom, 0.5 = centered, 1 = exiting top
      var offset = (progress - 0.5) * maxOffset * 2;
      mediaWrapper.style.transform = 'translateY(' + offset + 'px)';
    }

    // Run once immediately on load
    applyParallax();

    window.addEventListener('scroll', function () {
      requestAnimationFrame(applyParallax);
    }, { passive: true });

    window.addEventListener('resize', applyParallax, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
